import React, {useRef} from 'react'
import PropTypes from 'prop-types'

import CustomInput from 'js/components/shared/FormElements/CustomInput';

import classnames from 'classnames/bind'

import styles from './FieldInput.module.scss'

const cx = classnames.bind(styles)

const FieldInput = function (props) {
  const {
    id,
    className,
    name,
    label,
    help,
    placeholder,
    onChange,
    onClear,
    required,
    value,
    autoFocus,
    error,
    touched = false,
    clearable,
  } = props;
  const inputRef = useRef(null)

  const onInputClear = function () {
    onChange('');
    inputRef.current.focus();
    onClear && onClear();
  }

  return (
    <div className={cx('root', className, {'required': required})}>
      {label && (
        <label htmlFor={id} className={cx('label')}>
          <span className={cx('label-text')}>{label}</span>
          {help && (<span className={cx('help')}>{help}</span>)}
        </label>
      )}
      <CustomInput
        id={id}
        ref={inputRef}
        required={required}
        placeholder={placeholder}
        onClear={clearable ? onInputClear : null}
        meta={{invalid:!!error, touched}}
        input={{onChange, name, required, value, autoFocus}}
      />
      {error && (
        <p className={cx('error')}>{error}</p>
      )}
    </div>
  )
}

FieldInput.defaultProps = {
  id: '',
  className: '',
  label: '',
  checked: false,
  error: '',
  onChange: () => ({}),
  isCsMask: false,
  formFields: {},
  syncErrors: {},
  autoFocus: false,
  clearable: false,
}

FieldInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  validate: PropTypes.any,
  error: PropTypes.string,
  isCsMask: PropTypes.bool,
  formFields: PropTypes.object,
  syncErrors: PropTypes.object,
  autoFocus: PropTypes.bool,
  clearable: PropTypes.bool,
}

// export default Input
export default FieldInput;
